<template>
  <nav class="navbar is-dark" role="navigation">
    <div class="navbar-brand">
      <a class="navbar-item">
        🔥 <strong class="ml-2">EVT Wildfire Forecast System</strong>
      </a>

      <a
        role="button"
        class="navbar-burger"
        :class="{ 'is-active': isActive }"
        @click="toggleMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isActive }">
      <!-- Left -->
      <div class="navbar-start">
        <RouterLink to="/" class="navbar-item">Dashboard</RouterLink>
        <RouterLink to="/analytics" class="navbar-item">Analytics</RouterLink>
        <RouterLink to="/forecast" class="navbar-item">Forecast</RouterLink>
        <RouterLink to="/reports" class="navbar-item">Reports</RouterLink>
      </div>

      <!-- Right -->
      <div class="navbar-end">
        <div class="navbar-item">
          <span class="tag is-success is-light">
            <DateThSection />
          </span>
        </div>

        <div class="navbar-item">
          <span class="tag is-success is-light"> ● System Online </span>
        </div>

        <div class="navbar-item">
          <button class="button is-small is-light" @click="toggleTheme">
            {{ isDark ? "☀️ Light Mode" : "🌙 Dark Mode" }}
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from "vue";

import DateThSection from "./DateThSection.vue";

const isActive = ref(false);
const isDark = ref(false);

const toggleMenu = () => {
  isActive.value = !isActive.value;
};

const toggleTheme = () => {
  isDark.value = !isDark.value;

  if (isDark.value) {
    document.documentElement.classList.add("dark-mode");
  } else {
    document.documentElement.classList.remove("dark-mode");
  }
};
</script>

<style>
.dark-mode {
  background-color: #1e1e1e;
  color: white;
}
</style>
